/* eslint-disable angular/controller-name */
/* eslint-disable angular/controller-as */

(function iife() {
	"use strict";

	angular.module("dx.webapp.node").controller("dxNodeCreateEditController", nodeCreateEditController);

	function nodeCreateEditController(
		$scope,
		$timeout,
		$rootScope,

		dxSession,
		RoleTypeEnum,
		NodeTypeEnum,
		QualityStatusEnum,
		CountryList,
		UIStateManager,
		dxLocalize,
		validationService,
		dxBitFlagsHelper,
		DX_REMOTE_PROCTOR_SETTING
	) {
		var self = this;
		self.$scope = $scope;
		self.updatedNode = angular.copy($scope.node);
		self.RoleTypeEnum = RoleTypeEnum;

		self.state = new UIStateManager("default");
		self.showSavedMessage = false;
		self.examAdminEmail = "";
		self.examAdminEmailError = null;
		self.roleType = dxSession.getRole().roleType;

		self.countryList = CountryList;
		self.nodeTypes = [];
		self.qualityStatus = [];
		self.schoolList = [];
		self.featureRemoteProctoringEnabled = dxBitFlagsHelper.isBitIncluded(self.updatedNode.remoteProctoringSetting, DX_REMOTE_PROCTOR_SETTING.ProctoringEnabled);

		$scope.$watch("vm.featureRemoteProctoringEnabled", function remoteProctorUpdated() {
			if (self.featureRemoteProctoringEnabled) {
				self.updatedNode.remoteProctoringSetting = dxBitFlagsHelper.addBit(self.updatedNode.remoteProctoringSetting, DX_REMOTE_PROCTOR_SETTING.ProctoringEnabled);
			} else {
				self.updatedNode.remoteProctoringSetting = dxBitFlagsHelper.removeBit(self.updatedNode.remoteProctoringSetting, DX_REMOTE_PROCTOR_SETTING.ProctoringEnabled);
			}
		});

		$scope.$watch("vm.updatedNode", function nodeUpdated(newVal, oldVal) {
			if (newVal !== oldVal) {
				if (self.updatedNode !== $scope.node) {
					$scope.unsavedChanges(true);
				}
			}
		}, true);

		angular.forEach(NodeTypeEnum, function forEachNodeType(value) {
			self.nodeTypes.push(value);
		});

		angular.forEach(QualityStatusEnum, function forEachQualityStatus(value) {
			self.qualityStatus.push(value);
		});

		self.saveNode = function saveNode() {
			self.state.set("saving");
			var promise = self.updatedNode.save();
			promise.then(function saveSuccess(response) {
				if (response.faults) {
					$rootScope.$broadcast("notification:error", "Could not save organization information.");
				} else {
					self.showSavedMessage = true;
					$timeout(function saveMessageTimeout() {
						self.showSavedMessage = false;
					}, 2000);
					if ($scope.saveCallback) {
						$scope.saveCallback(response);
					}

					for (var k in self.updatedNode) {
						if (self.updatedNode.hasOwnProperty(k)) {
							$scope.node[k] = self.updatedNode[k];
						}
					}
					$scope.unsavedChanges(false);
				}
				self.state.set("default");
			}, function saveError(err) {
				var errMsg = "Could not save organization information.";
				if (err.data.msgs && err.data.msgs.length) {
					errMsg += "\n" + err.data.msgs[0];
				}
				$rootScope.$broadcast("notification:error", errMsg);
				self.state.set("default");
			});
		};

		self.addExamAdminContact = function addExamAdminContact() {
			if (self.updatedNode.examAdminEmails.indexOf(self.examAdminEmail) !== -1) {
				self.examAdminEmail = "";
				return;
			}

			if (!validationService.isEmailValid(self.examAdminEmail, true)) {
				self.examAdminEmailError = dxLocalize.get("InvalidEmail");
				return;
			}

			self.updatedNode.examAdminEmails.push(self.examAdminEmail);
			self.examAdminEmail = "";
		};

		self.removeExamAdminContact = function removeExamAdminContact(email) {
			for (var i = self.updatedNode.examAdminEmails.length - 1; i >= 0; i--) {
				if (self.updatedNode.examAdminEmails[i] === email) {
					self.updatedNode.examAdminEmails.splice(i, 1);
				}
			}
		};
	}
}());
